module.exports = __webpack_public_path__ + "static/media/main-stage-4.fd405322.png";